export function migrateOldPipingEquipments() {
  if (typeof localStorage === 'undefined') return;

  try {
    const dataStr = localStorage.getItem('inspect_equipments');
    if (!dataStr) return;
    
    const data = JSON.parse(dataStr);
    let changed = false;
    let count = 0;

    const migratedData = data.map((item: any) => {
      const isTuple = Array.isArray(item) && item.length === 2 && typeof item[0] === 'string';
      const obj = isTuple ? item[1] : item;

      if (obj && (obj.equipmentType === 'PIPING_LINE' || obj.equipmentType === 'PIPING_SYSTEM' || obj.equipmentType === 'PIPING')) {
        let objChanged = false;

        // Migrar a nova regra de "Sistema de Tubulação" (Applicability)
        if (obj.pipeSystemApplicability === undefined) {
          obj.pipeSystemApplicability = (obj.system && obj.system.trim().length > 0 && obj.system !== 'NÃO INFORMADO' && obj.system !== '-') ? 'APPLICABLE' : 'NOT_APPLICABLE';
          objChanged = true;
        }

        // Inicializar os novos campos técnicos para não dar crash ou undefined na leitura
        const newFields = [
          'spec', 'pressureClass', 'materialFamily', 'materialSpecification', 
          'materialGrade', 'dimensionalStandard', 'calculatedInnerDiameter', 
          'dimensionSource', 'dimensionManualSource', 'dimensionManualJustification'
        ];
        
        newFields.forEach(field => {
          if (obj[field] === undefined) {
            obj[field] = null;
            objChanged = true;
          }
        });

        if (obj.pipingClass) {
          const pClass = obj.pipingClass;
          const ratingMatch = pClass.match(/(?:Rating|Class|Classe)\s*(\d+)/i);
          let extractedClass = null;
          let extractedSpec = pClass;

          if (ratingMatch && ratingMatch[1]) {
            extractedClass = ratingMatch[1];
            extractedSpec = pClass.split('-')[0].trim();
          }

          obj.spec = extractedSpec;
          obj.pressureClass = extractedClass;
          delete obj.pipingClass;
          objChanged = true;
        }

        // Set default dimensionSource to CATALOG if it has schedule
        if (obj.dimensionSource === null && obj.schedule) {
            obj.dimensionSource = 'CATALOG';
            objChanged = true;
        }

        if (objChanged) {
            changed = true;
            count++;
        }
      }
      return isTuple ? [item[0], obj] : obj;
    });

    if (changed) {
      localStorage.setItem('inspect_equipments', JSON.stringify(migratedData));
      console.log(`%c[MIGRATION] ${count} equipamentos de tubulação antigos atualizados com os novos itens do modelo!`, "color: #10b981; font-weight: bold;");
    }
  } catch (e) {
    console.error('Erro na migração de equipamentos:', e);
  }
}
